import { Outlet } from 'react-router-dom';
import { FeatureTourProvider } from '@/contexts/FeatureTourContext';
import { InteractiveTour } from '@/components/feature-tour/InteractiveTour';
import { useNativePush } from '@/hooks/useNativePush';

function NativePushInitializer() {
  useNativePush();
  return null;
}

export function RootLayout() {
  return (
    <FeatureTourProvider>
      <NativePushInitializer />
      <Outlet />
      <InteractiveTour />
    </FeatureTourProvider>
  );
}
